import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import { SectionTitle, RowText, Checkbox } from './SectionForm.styles';

const SectionForm = ({
  permissions,
  values,
  onChangeCheckbox,
  arrayHelpers,
  title,
}) => {
  return (
    <Box>
      <SectionTitle>{title}</SectionTitle>
      {permissions.map(permission => (
        <Box horizontal align="center" py={13} key={permission.name}>
          <Checkbox
            type="checkbox"
            data-name={permission.name}
            name={permission.name}
            value={permission.name}
            checked={!!values.permissions.find(p => p === permission.name)}
            onChange={e =>
              onChangeCheckbox(e, arrayHelpers, permission, values)
            }
          />
          <RowText>{permission.display_name}</RowText>
        </Box>
      ))}
    </Box>
  );
};

export default SectionForm;
